import React from "react";
import { useIntl } from "react-intl";
import { isDefined } from "../../_lib/is-defined";
import { RegisterTable } from "../../_lib/register-table";
import useTimeZone from "../../_lib/use-time-zone";
import type { RegisterRecordsQuery } from "../__generated__/page.gql";
import { getViewColumns } from "./columns";
import { createRowFormatter } from "./create-row-formatter";

export const PatientRegisterTable = ({
  currentPage,
  setCurrentPage,
  loading,
  data,
}: {
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  loading: boolean;
  data?: RegisterRecordsQuery;
}) => {
  const { formatMessage } = useIntl();
  const timeZone = useTimeZone();
  const rowFormatter = createRowFormatter(timeZone, formatMessage);

  return (
    <RegisterTable
      errorBoundaryName="patient-register-table"
      currentPage={currentPage}
      setCurrentPage={setCurrentPage}
      loading={loading}
      columns={getViewColumns(formatMessage)}
      rows={
        data?.registerRecords?.records?.filter(isDefined).map(rowFormatter) ||
        []
      }
      totalRows={data?.registerRecords?.total ?? 0}
    />
  );
};
